import React from 'react'
import PropTypes from 'prop-types'

import Button from '../general/Button'

const BotButton = ({ botName, ...restProps }) => {
    return <Button linkTo='/office-search' state={{ botName }} {...restProps} />
}

BotButton.propTypes = {
    botName: PropTypes.string,
}

BotButton.defaultProps = {
    botName: 'LandBot',
}

export default BotButton
